import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import type { PriceFilterViewModel } from 'autogen/swagger/all';
import { PriceIntervalLabel } from 'autogen/translation-keys/trans-website-filter';
import useDrawer from 'components/generic/Drawer/hooks/useDrawer';
import { Typography } from 'components/generic/typography';
import FilterListItem from 'components/List/components/FilterListItem';
import { format } from 'modules/helpers/strings';
import { findNSelectedOptions } from '../shared/helpers';

const PreviewText = styled(Typography.Body)`
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    max-width: 50%;
`;

export default function RootPriceFilterMenuItem({ model }: { model: PriceFilterViewModel }) {
    const {
        displayName,
        prices,
        priceInterval,
        attribute: { id }
    } = model;
    const filterMenuId = id.toString();
    const { toggle } = useDrawer(filterMenuId);
    const selectedOptions = findNSelectedOptions(prices.options, 8).map((option) => option.displayName);
    const { t } = useTranslation();

    const selectedOptionsPreviewText = !!selectedOptions.length && (
        <PreviewText forwardedAs="span" size="S" strong>
            {selectedOptions.join(', ')}
        </PreviewText>
    );

    const selectedIntervalPreivewText = priceInterval.minValue && priceInterval.maxValue && (
        <PreviewText forwardedAs="span" size="S" strong>
            {format(t(PriceIntervalLabel))(priceInterval.minValue, priceInterval.maxValue)}
        </PreviewText>
    );

    return (
        <FilterListItem.Button
            type="navigation"
            selectedPreview={selectedOptionsPreviewText || selectedIntervalPreivewText}
            buttonProps={{ onClick: toggle }}
        >
            {displayName}
        </FilterListItem.Button>
    );
}
